import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserTypeComponent } from './user-type.component';
import { ReactiveFormsModule } from '@angular/forms';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [UserTypeComponent],
  imports: [CommonModule, ReactiveFormsModule, TranslateModule],
  exports: [UserTypeComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class UserTypeModule {}
